<div class="container">
    <div class="row no-gutters">
      <div class="col-12">
        <div class="d-flex popup-head align-items-center">
            <div class="popup-title mr-auto" translate>
                <ng-container *ngIf="Id === 0;else load_else " translate>
                  lblAddLabor
                </ng-container>
                <ng-template #load_else translate>
                  lblEditLabor
                 </ng-template>
              </div>
          <div class="float-right">
            <a class="close mr-3" (click)="OnClose()" translate>
              <span class="" aria-hidden="true">&times;</span>
              </a>
          </div>
          
        </div>
        <form [formGroup]="LaborForm" (ngSubmit)="AddEditLabor()">
          <div class=" scrollbar">
            <div class="card-content">
              <div class="card-body p-0">
                <div class = "form-row">
                  <div class="col-lg-6 col-xl-3 af-form-group">
                      <label for="service" translate>lblLaborNumber
                        <strong class="mlt6 required"> * </strong> </label>
                      <div class='lbl-info'>
                        <input formControlName="laborNumber" class="form-control mb-2" maxlength="20" [value] = "cpf.laborNumber.value?.toUpperCase()"
                          required>
                        <div *ngIf="cpf.laborNumber.touched && (cpf.laborNumber.errors?.required)" class="help-block mt-1 text-danger"
                          translate>
                          lblLaborNumberRequired
                        </div>
                      </div>
                    </div>
                  </div>
                <div *ngIf="Id == 0">
                  <div class="form-row" *ngIf="t">
                    <div class="col-lg-6 col-xl-3" *ngFor="let ticket of t.controls; let i = index">
                      <div  [formGroup]="ticket">
                        <div class="af-form-group">
                          <label for="name"><span translate>lblName</span><span> in
                              {{languageList[i].value}}</span>
                            <strong class="mlt6 required"> * </strong> </label>
                          <div class="lbl-info">
                            <input formControlName="name" class="form-control mb-2" maxlength="50"
                            [ngClass]="{'is-invalid': cpf.labor.invalid && cpf.labor.touched}">
                            <div *ngIf="cpf.labor.touched && (cpf.labor.errors?.required)"
                              class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                                aria-hidden="true"></em>
                                lblNameRequired
                            </div>
                          </div>
                        </div>
  
                        <div class="af-form-group" style="display: none;">
                          <label for="languageId" translate>Language Id</label>
                          <div class="lbl-info">
                            <input formControlName="languageId" class="form-control mb-2" [ngModel]="languageList[i].id"
                              maxlength="50">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="Id != 0 && laborDetail != undefined">
                    <div class="form-row" *ngIf="t">
                      <div class="col-lg-6 col-xl-3" *ngFor="let ticket of t.controls; let i = index">
                        <div  [formGroup]="ticket">
                          <div class="af-form-group">
                            <label for="name"><span translate>lblName</span><span> in
                                {{languageList[i].value}}</span>
                              <strong class="mlt6 required"> * </strong> </label>
                            <div class="lbl-info">
                              <input formControlName="name" class="form-control mb-2" maxlength="50"  [(ngModel)]="laborDetail.laborLanguageDetails[i].name"
                              [ngClass]="{'is-invalid': cpf.labor.invalid && cpf.labor.touched}">
                              <div *ngIf="cpf.labor.touched && (cpf.labor.errors?.required)"
                                class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                                  aria-hidden="true"></em>
                                  lblNameRequired
                              </div>
                            </div>
                          </div>
    
                          <div class="af-form-group" style="display: none;">
                            <label for="languageId" translate>Language Id</label>
                            <div class="lbl-info">
                              <input formControlName="languageId" class="form-control mb-2" [ngModel]="languageList[i].id"
                                maxlength="50">
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="form-row">
                  <!-- Price -->
                  <div class="col-lg-6 col-xl-3 af-form-group" >
                    <label for="service" translate>lblPrice <span class="text-sm1" translate>lblExclVat</span>
                      <strong class="mlt6 required"> * </strong> </label>
                    <div class='lbl-info'>
                      <input formControlName="fixedPrice" pattern="^[\d,.\s]+$" class="form-control mb-2" maxlength="10" required
                         pattern="^[\d,.\s]+$" (blur)="onBlur($event)">
                      <div *ngIf="cpf.fixedPrice.touched && (cpf.fixedPrice.errors?.required)" class="help-block mt-1 text-danger"
                        translate>
                        lblPriceRequired
                      </div>
                      <div *ngIf="cpf.fixedPrice.touched && (cpf.fixedPrice.errors?.pattern)" class="help-block mt-1 text-danger"
                      translate>
                      lblOnlyNumbersAreAllowed
                    </div>
                    </div>
                  </div>
                  <!-- PriceInclVAT -->
                  <div class="col-lg-6 col-xl-2 af-form-group" >
                    <label for="service" translate>lblPrice <span class="text-sm1" translate>lblInclVAT</span>
                      <strong class="mlt6 required"> * </strong> 
                    </label>
                    <div class='lbl-info'>
                      <input formControlName="priceInclVAT" pattern="^[\d,.\s]+$" class="form-control mb-2" disabled >
                    </div>
                  </div>
                  <div class="col-lg-6 col-xl-3 af-form-group">
                    <label for="service" translate>
                      <span translate>lblDuration</span>
                      <strong class="mlt6 required"> * </strong> </label>
                    <div class='lbl-info'>
                      <input placeholder="hh:mm" formControlName="duration" class="form-control mb-2" pattern="^\d{2}:\d{2}$" maxlength="5"
                        required (keypress)="isDigit($event)"  (input)="CheckDuration($event)"> 
                      <div *ngIf="cpf.duration.touched && (cpf.duration.errors?.required)"
                        class="help-block mt-1 text-danger" translate> <em class="ft-alert-circle align-middle"
                          aria-hidden="true"></em>
                        lblDurationRequired
                      </div>
                      <div *ngIf="cpf.duration.touched && (cpf.duration.errors?.pattern)"
                        class="help-block mt-1 text-danger" translate>
                        lblInvalidDuration
                      </div>
                    </div>
                  </div>
                  <div class=" col-lg-6 col-xl-3 af-form-group">
                    <label for="template-make" translate>lblMake<strong class="mlt6 required">
                        *</strong> </label>
                    <div class='lbl-info'>
                      <ng-select formControlName="makeCode" placeholder="{{ 'lblSelectMake' | translate }}" required
                        [(ngModel)]="makeCode" [ngClass]="{'ng-select-is-invalid':(cpf.makeCode.invalid  && cpf.makeCode.touched) || (cpf.makeCode.invalid  && isFormValid)}">
                        <ng-template ng-header-tmp>
                          <span class="mbold w-66px">Code</span>
                          <span class="mbold" translate>lblMake</span>
                        </ng-template>
    
                        <ng-option *ngFor="let type of makeList" [value]="type.brandCode">
                          <span class="w-66px">{{type.brandCode}}</span>
                          <span class="mx-2 hide-ng-dropdown-panel">-</span>
                          <span>{{type.brandName}}</span>
                        </ng-option>
                      </ng-select>
                      <div *ngIf="(cpf.makeCode.invalid && (cpf.makeCode.dirty || cpf.makeCode.touched)) || (cpf.makeCode.invalid && isFormValid)" class="help-block text-danger">
                        <div *ngIf="cpf.makeCode.errors.required"><span translate>lblRequiredMake</span>
                        </div>
                      </div>
                    </div>
    
                  </div>
                  <!-- Charging Group dropdown -->
                  <div class=" col-lg-6 col-xl-3 af-form-group" *ngIf="!allowDealerBrandLaborRate">
                    <label for="template-make" translate>lblChargingGroup</label>
                    <div class='lbl-info'>
                      <ng-select formControlName="chargingGroup" placeholder="{{ 'lblSelectChargingGroup' | translate }}" required
                        [(ngModel)]="chargingGroup">
                        <ng-template ng-header-tmp>
                          <span class="mbold w-66px" translate>lblCode</span>
                          <span class="mbold" translate>lblName</span>
                        </ng-template>
                  
                        <ng-option *ngFor="let type of chargingGroupList" [value]="type.groupNo">
                          <span class="w-66px">{{type.groupNo}}</span>
                          <span class="mx-2 hide-ng-dropdown-panel">-</span>
                          <span>{{type.charginGroupName}}</span>
                        </ng-option>
                      </ng-select>
                    </div>
                  
                  </div>

                  <div class="col-2 mt-2">
                    <div class="af-form-group mt-4">
                    <div class="custom-control custom-switch">
                      <input type="checkbox" class="custom-control-input" id="isFixed"
                        [checked]="LaborForm.value.isFixed" (change)="onChangeIsFixed($event)">
                      <label class="custom-control-label" for="isFixed">
                        <span translate>lblIsFixed</span>
                      </label>
                    </div>
                  </div>
                </div>
                  <div class="col-1 mt-2">
                        <div class="af-form-group mt-4">
                        <div class="custom-control custom-switch">
                          <input type="checkbox" class="custom-control-input" id="isActive"
                            [checked]="LaborForm.value.isActive" (change)="onChangeIsActive($event)">
                          <label class="custom-control-label" for="isActive">
                            <span translate>lblActive</span>
                          </label>
                        </div>
                      </div>
                    </div>
                    
                </div>
                <div  class="form-row">
                    <div class="col-12">
                        <strong><label class="" translate>lblNoteLaborHourlyRate</label></strong>
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div class="p-3 bg-light pp-footer-top-brdr">
          <div class="row">
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
              <button type="submit" class="btn btn-primary btn-lg mr-sm-2" *ngIf="Id == 0" aria-label="Center Align" [disabled]="!LaborForm.valid" translate><em class="fa fa-plus font16 align-top mr-2"></em>lblAdd
              </button>
              <button type="submit" class="btn btn-primary btn-lg mr-sm-2" *ngIf="Id != 0" aria-label="Center Align" [disabled]="!LaborForm.valid" translate><em class="far fa-save font16 align-top mr-2"></em>lblUpdate
                </button>
              <a  (click)="OnClose()" type="reset" class="btn btn-secondary btn-lg" translate><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</a>
            </div>
          </div>
        </div>
        </form>
      </div>
    </div>
  </div>